import { useCallback, useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from "../../configuration/config";
import { trimEnd, groupBy, mapValues, omit } from "lodash";
import { useHistory } from "react-router";
import Skeleton from "react-loading-skeleton";

import { useUserCart } from "../../User/hooks/useUserCart";
import { useUserFavorite } from "../../User/hooks/useUserFavorite";
import ImageGallery from "react-image-gallery";

import { CarCheckoutPage } from "./carCheckout";
import { CarCheckoutCashPage } from "./carCheckoutCash";
import { CarCashAccessoriesPage } from "./carCashAccessories";
import { CarCheckoutReservationPage } from "./carCheckoutReservation";
import { CarCheckoutFinancePage } from "./carCheckoutFinance";
import { callFuncData } from "../../services/funcService";
import { slugSplitter } from "../../utils/slugManager";
import * as journifyTrackingCarEvents from "../../services/trackingCarEvents";

// Import new child components
import Breadcrumb from "../../components/__simple/breadcrumb";
import OverviewHeader from "../../components/carOverview2/OverviewHeader";
import ProtectionShadingTabs from "../../components/carOverview2/ProtectionShadingTabs";
// import Specifications from "../../components/carOverview2/Specifications";
import ExtraDetailsPanel from "../../components/carOverview2/ExtraDetailsPanel";
import FinanceCalculator from "../../components/carOverview2/FinanceCalculator";
import DeliveryInfo from "../../components/carOverview2/DeliveryInfo";
import SuggestedVehicles from "../../components/carOverview2/SuggestedVehicles";
import MobileStickyFooter from "../../components/carOverview2/MobileStickyFooter";
import DesktopSidebar from "../../components/carOverview2/DesktopSidebar";
import SharePopup from "../../components/carOverview2/SharePopup";
import FinancingDetailsPopup from "../../components/carOverview2/FinancingDetailsPopup";

export function CarOverviewPage2({ ...props }) {
  const history = useHistory();
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const { slug, sn, page } = useParams();
  const { t: trans, i18n } = useTranslation(["new", "finance", "inputs", "info", "new"]);
  const [activePart, setActivePart] = useState(0);
  const [Cart, setCart] = useState({
    Id: "",
    colorID: "",
    colorNameEn: "",
    modelTypeDescEn: "",
    groupEn: "",
    brandEn: "",
    modelTypeDesc: "",
    Price: 0,
    Discount: 0,
    Tax: 0,
    ProductID: "",
    colorName: "",
    group: "",
    brand: "",
    year: "",
    modelType: "",
    showPric: false,
    BrandID: "",
    MiniDownPayment: 0,
  });
  const { changecartItem } = useUserCart();
  const [activeINColor, setActiveINColor] = useState("");
  const [activeOutColor, setActiveOutColor] = useState("");
  const [vehicle, setVehicle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [shareData, setShareData] = useState({ title: "", hashTag: "", url: "" });
  useEffect(() => {
    if (vehicle) {
      setShareData({
        title: vehicle.name || "",
        hashTag: `${vehicle.brand || ""},${vehicle.name || ""}`.replaceAll(" ", ""),
        url: window.location.href,
      });
    }
  }, [vehicle]);
  const [shareOpened, setShareOpened] = useState(false);
  let lang = (i18n.language || 'ar');
  const [isFullScreen, setIsFullScreen] = useState(false);
  const popGalleryRef = useRef(null);
  const [isLoadingImages, setIsLoadingImages] = useState(false);
  const [showFinalPopupMessage, setShowFinalPopupMessage] = useState("");
  const [showPanel, setShowPanel] = useState(false);
  const [indexPanel, setIndexPanel] = useState("-1");
  const [activeFilterMenu, setActiveFilterMenu] = useState(0);
  const { isFavoriteItem, changeFavoriteItemState } = useUserFavorite();
  const [scrollSnackUp, setScrollSnackUp] = useState({
    show: false,
    height: "16rem",
  });

  const vehicleFeatures = [
    { title: trans("new:year"), fieldName: "year" },
    { title: trans("new:hourse"), fieldName: "hp" },
    { title: trans("new:number_of_seats"), fieldName: "seatsNumber" },
    { title: trans("new:cylinders"), fieldName: "cylinders" },
    { title: trans("new:liter"), fieldName: "liter" },
    { title: trans("new:petrol"), fieldName: "petrol" },
  ];
  const [activeModel, setActiveModel] = useState("");
  const [features, setFeatures] = useState([]);
  const [extraDetails, setExtraDetails] = useState([]);
  const [models, setModels] = useState([]);
  const [suggestedVehicles, setSuggestedVehicles] = useState([]);
  const [colors, setCarColors] = useState([]);
  const [INcolors, setINCarColors] = useState([]);
  const [OUTcolors, setOUTCarColors] = useState([]);
  const [jsonColors, setJsonColors] = useState({});
  const [innerCarImages, setInnerCarImages] = useState([]);
  const [allCarImages, setAllCarImages] = useState([]);
  const [outerCarImages, setOuterCarImages] = useState([]);
  const [wheels, setWheels] = useState([]);
  const [allImagesCount, setAllImagesCount] = useState(null);
  const [Shipping, setShipping] = useState({ UnitTime: "", CountTime: 0, Cost: 0, CostWithTax: 0, DateTimeDelevry: "" });
  const [valueDelevaryCitie, setValueDelevaryCitie] = useState("0");
  const [vehicleOffers, setVehicleOffers] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [productTypes, setProductTypes] = useState([]);
  const [defaultProductModel, setDefaultProductModel] = useState(null);
  const [cashColors, setCashColors] = useState({});
  const [INcolorsCode, setINCarColorsCode] = useState([]);
  const [OUTcolorsCode, setOUTCarColorsCode] = useState([]);

  const [selectcity, setSelectcity] = useState(null);
  const [selectBranch, setSelectBranch] = useState(null);

  const setCartData = (item) => {
    if (item) {
      var obb = {
        id: Cart?.Id,
        Type: "car",
        colorId: Cart?.colorID,
        name: Cart?.modelTypeDesc,
        nameEn: Cart?.modelTypeDescEn,
        price: Cart?.Price,
        brand: Cart?.brand,
        brandEn: Cart?.brandEn,
        Tax: Cart?.Tax,
        image: Cart?.image,
        Discount: Cart?.Discount,
        productID: Cart?.ProductID,
        group: Cart?.group,
        groupEn: Cart?.group,
        BrandID: Cart?.BrandID,
        modelTypes: Cart?.modelTypeDesc,
        modelTypesEn: Cart?.modelTypeDescEn,
        colorName: Cart?.colorName,
        colorNameEn: Cart?.colorNameEn,
        year: Cart?.year,
        modelTypeID: Cart.modelType,
        MiniDownPayment: Cart?.MiniDownPayment,
        SN: Cart.SN,
        Slug: Cart.Slug,
      };
      changecartItem(Cart.ProductID, Cart.colorID, Cart.modelType, 1, null, null, obb, null, Cart?.year);
    }
  };

  // Removed redundant useEffect for sn as it is now handled in callback

  const [loadingFetchVehicleDetailsByVIN, setLoadingFetchVehicleDetailsByVIN] = useState(false);
  const fetchVehicleDetailsByVIN = useCallback(async (vin) => {
    var id = query.get("OrderGUID")?.trim();
    if (id) return;
    try {
      setLoadingFetchVehicleDetailsByVIN(true);
      const response = await callFuncData("GetVehicleDetailsByVIN", { VIN: vin });
      const vDetails = response[0];
      console.log("fetchVehicleDetailsByVIN:", vDetails);
      console.log("ProductNo:", vDetails.ProductNo);
      if (vDetails) {
        if (vDetails?.BuyOnline != true && vDetails?.BuyOnline != 1 && vDetails?.BuyOnline != "1") {
          history.push({ pathname: `/VehicleOnline`, search: "" });
        }
        setLoadingFetchVehicleDetailsByVIN(false);
        return vDetails;
      } else {
        return null;
      }
    } catch (error) {
      setLoadingFetchVehicleDetailsByVIN(false);
    }
  }, [query, history]);

  useEffect(() => {
    if (selectedColor) {
      const selectdM = models?.find((item) => item?.Type == selectedColor?.Type) ?? null;
      try {
        const currentValues = { ...Cart };
        currentValues.Id = selectedColor?.GUID;
        currentValues.brand = selectedColor["Brand Arabic"];
        currentValues.brandEn = selectedColor["Brand English"];
        currentValues.group = selectedColor["Group Arabic"];
        currentValues.groupEn = selectedColor["Group English"];
        currentValues.colorName = selectedColor["ColorDescriptionAr"];
        currentValues.colorNameEn = selectedColor["ColorDescriptionEn"];
        currentValues.colorID = selectedColor?.ColorID;
        currentValues.Price = selectedColor?.NetSalePrice;
        currentValues.Tax = selectedColor?.TaxAmount;
        currentValues.Discount = selectedColor?.Discount;
        currentValues.ProductID = selectedColor?.ProductID;
        currentValues.BrandID = selectedColor?.BrandID;
        currentValues.image = selectdM?.Image ?? (filterCarImages && filterCarImages[0]?.Image_URL);
        currentValues.modelType = selectedColor?.Type;
        currentValues.modelTypeDesc = selectedColor["Type Arabic"];
        currentValues.modelTypeDescEn = selectedColor["Type English"];
        currentValues.showPric = selectedColor?.showPric;
        currentValues.year = selectedColor?.Model;
        currentValues.MiniDownPayment = selectedColor.MiniDownPayment;
        currentValues.SN = selectedColor.SN;
        currentValues.Slug = selectedColor.ProductTarget;
        setCart(currentValues);
      } catch (err) { }
    }
  }, [selectedColor]);

  useEffect(() => {
    handleFetchCountries();
    GetBranch();
  }, []);

  useEffect(() => {
    callback();
    fetchFinanceSettings();
    initialBanksData();
  }, []);

  const firedRef = useRef(false);
  useEffect(() => {
    if (vehicle) fetchService();
    if (vehicle && page?.toLowerCase() == "overview" && !firedRef.current) {
      firedRef.current = true;
      journifyTrackingCarEvents.trackViewCar(vehicle);
    }
  }, [vehicle, page]);

  const [isLoadingBanks, setLoadingBanks] = useState(true);
  const [banks, setBanks] = useState([]);
  const initialBanksData = (active = true) => {
    setLoadingBanks(true);
    axios
      .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchActiveBankWithFinanceSettings`, {})
      .then((response) => {
        const result = response.data;
        setBanks(result);
        setLoadingBanks(false);
      })
      .catch((error) => setLoadingBanks(false));
  };

  const [vehiclePriceList, setVehiclePriceList] = useState([]);
  const FetchVehiclePriceList = (PriceListTypeID, ProductGroupID, Model, ColorID, Type) => {
    axios
      .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FetchVehiclePriceListOnline`, { PriceListTypeID, ProductGroupID, Model, ColorID, Type })
      .then((response) => {
        const result = response.data;
        setVehiclePriceList(result);
      })
      .catch((error) => { });
  };

  const [financeSettings, setFinanceSettings] = useState(null);
  const [finance, setFinance] = useState({ price: 0, month: 0, first: 0, last: 0, totalPrice: 0 });
  const [minFinance, setMinFinance] = useState({ price: 0, month: 0, first: 0, last: 0, totalPrice: 0 });

  const fetchFinanceSettings = () => { };

  useEffect(() => {
    if (finance.price && finance.price > 0 && (minFinance.price == null || minFinance.price == 0)) {
      setMinFinance(finance);
    }
  }, [finance, minFinance]);

  useEffect(() => {
    if (banks?.length > 0) {
      const minBank = banks.reduce((min, bank) => {
        const currentValue = bank.FinanceRate + bank.ManagementFees;
        const minValue = min.FinanceRate + min.ManagementFees;
        return currentValue < minValue ? bank : min;
      }, banks[0]);
      setFinanceSettings(minBank);
    }
  }, [banks]);

  const [selectedFinancePeriod, setSelectedFinancePeriod] = useState(60);
  const [minFirstPayPrice, setMinFirstPayPrice] = useState(0);

  const reCountFinanceSettings = (financeSettings, selectedFinancePeriod, currentFirstPayPrice) => {
    try {
      if (selectedColor && financeSettings && vehiclePriceList?.length > 0) {
        var NetSalePrice = selectedColor?.NetSalePrice;
        var vehiclePrice = vehiclePriceList?.find(
          (item) => item.ColorID == selectedColor?.ColorID && item.Type == selectedColor?.Type && item.Model == selectedColor?.Model && item.PriceListTypeID == financeSettings?.PriceListTypeID
        );
        if (vehiclePrice) {
          NetSalePrice = vehiclePrice?.MinPrice;
        }
        let financeData = { ...finance };
        if (NetSalePrice && financeSettings?.ManagementFees >= 0) {
          const firstPay = financeSettings?.AdvancedPaymentRate / 100 ?? 0;
          const lastPay = financeSettings?.LastPaymentRate / 100 ?? 0;
          const managementFees = financeSettings?.ManagementFees / 100 ?? 0;
          const financeRate = financeSettings?.FinanceRate / 100 ?? 0;

          setMinFirstPayPrice(parseInt(firstPay * NetSalePrice));

          const firstPayPrice = currentFirstPayPrice ? currentFirstPayPrice : firstPay * parseFloat(NetSalePrice);
          const lastPayPrice = lastPay * parseFloat(NetSalePrice);
          const financeAmount = parseFloat(NetSalePrice) - parseFloat(firstPayPrice);

          var addAmount = financeAmount * financeRate * (selectedFinancePeriod / 12);
          var managementFeesAmount = 0;
          if (addAmount && managementFees && managementFees > 0) {
            managementFeesAmount = financeAmount * managementFees;
            managementFeesAmount = managementFeesAmount + managementFeesAmount * 0.15;
            addAmount = addAmount + managementFeesAmount;
          }

          const mounthBrach = (financeAmount + addAmount - lastPayPrice) / (selectedFinancePeriod - 1);
          const finalAmount = mounthBrach * (selectedFinancePeriod - 1) + lastPayPrice + firstPayPrice;

          financeData.period = selectedFinancePeriod;
          financeData.mangFees = managementFeesAmount;
          financeData.totalPrice = finalAmount;
          financeData.first = firstPayPrice;
          financeData.last = lastPayPrice;
          financeData.price = mounthBrach;
          setFinance(financeData);
        }
      }
    } catch (error) { }
  };

  useEffect(() => {
    reCountFinanceSettings(financeSettings, selectedFinancePeriod);
  }, [selectedColor, financeSettings, selectedFinancePeriod]);

  const [isToyota, setisToyota] = useState(false);
  const [isLexus, setisLexus] = useState(false);

  useEffect(() => {
    if (vehicle) {
      setisToyota(vehicle?.brand && (vehicle?.brand.toLowerCase() === "تويوتا" || vehicle?.brand.toLowerCase() === "toyota"));
      setisLexus(vehicle?.brand && (vehicle?.brand.toLowerCase() === "لكزس" || vehicle?.brand.toLowerCase() === "lexus"));
    }
    if (vehicle?.brandID && vehicle?.category && vehicle?.carGroupID) GetSuggestedVehicles(vehicle?.brandID, vehicle?.category, vehicle?.carGroupID, vehicle?.slug);
  }, [vehicle]);

  useEffect(() => {
    if (vehicle?.colorID && vehicle?.colorID?.split("/")[0] && vehicle?.colorID?.split("/")[1]) {
      setActiveOutColor(vehicle?.colorID?.split("/")[0]);
      setActiveINColor(vehicle?.colorID?.split("/")[1]);
    }
  }, [vehicle]);

  useEffect(() => {
    if (vehicle && cities && cities?.length > 0) {
      const cityToFetch = selectcity || cities[0]?.value;
      CarShippingInfo(cityToFetch);
    }
  }, [vehicle, cities, selectcity]);

  const deliveryTimeAccounting = useCallback(() => {
    try {
      if (Shipping?.CountTime && (Shipping?.UnitTime?.toLowerCase()?.includes("day") || Shipping?.UnitTime?.includes("يوم"))) {
        let dateNow = new Date();
        dateNow.setDate(dateNow.getDate() + Shipping?.CountTime);
        var formatDate = { year: "numeric", month: "2-digit", day: "2-digit", weekday: "long" };
        if (lang === "en") {
          return dateNow.toLocaleDateString("en-US", formatDate);
        } else {
          return dateNow.toLocaleDateString("ar-SA", formatDate);
        }
      } else {
        return Shipping?.UnitTime || "";
      }
    } catch (error) {
      return Shipping?.UnitTime || "";
    }
  }, [Shipping, lang]);

  const handleFetchModelAvaliableColors = useCallback(async (productTypeID, currentColorID, year, thisSelectedColorID = selectedColor?.ColorID) => {
    let _colors = [];
    try {
      if (cashColors[productTypeID]) {
        _colors = cashColors[productTypeID];
        setCarColors(_colors);
        let _default = null;
        if (thisSelectedColorID || selectedColor?.ColorID || currentColorID) {
          _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === (selectedColor?.ColorID || currentColorID));
        }
        if (!_default) {
          _default = _colors.find((item) => item.buyOnline == true);
          if (!_default) _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === (selectedColor?.ColorID || currentColorID));
        }
        setSelectedColor(_default);
      } else {
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_fetchColorOfTypeWithOutImages`, { Type: productTypeID, model: year });
        if (response.status == 200) {
          _colors = response.data?.filter((item) => item.buyOnline == 1 || item.buyOnline === true || item.buyOnline === "1");
          var cc = { ...cashColors };
          cc[productTypeID] = _colors;
          setCashColors(cc);
          setCarColors(_colors);
          let _default = null;
          if (thisSelectedColorID || selectedColor?.ColorID || currentColorID) {
            _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === (selectedColor?.ColorID || currentColorID));
          }
          if (!_default) {
            _default = _colors.find((item) => item.buyOnline == true);
            if (!_default) _default = _colors.find((item) => item.ColorID === thisSelectedColorID) ?? _colors.find((item) => item.ColorID === (selectedColor?.ColorID || currentColorID));
          }
          if (_default) { }
          setSelectedColor(_default);
        }
      }
    } catch (error) { }
    return _colors;
  }, [cashColors, selectedColor?.ColorID]);

  const [cashCarImages, setCashCarImages] = useState({});
  const [innerCarImagesJson, setInnerCarImagesJson] = useState(null);
  const [outerCarImagesJson, setOuterCarImagesJson] = useState(null);

  const fetchCarDesign = useCallback(async (activeColor, model, partnum = activePart) => {
    FetchCarSNImages(activeModel?.sn);
    if (isLoadingImages == false && OUTcolorsCode && OUTcolorsCode?.length > 0) {
      setIsLoadingImages(true);
      setFilterCarImages([]);
      var codeColor = partnum == 0 ? activeColor?.split("/")[0] : activeColor?.split("/")[1];
      var codeColorIN = activeColor?.split("/")[1];
      var codeColorOUT = activeColor?.split("/")[0];
      setAllImagesCount(0);
      var imagesPart = [];
      if (model) {
        if (cashCarImages[model + "-part-" + partnum]) {
          setIsLoadingImages(false);
          // var AllCarImages = cashCarImages[model + "-part-" + partnum];
          var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
          var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];
          setOuterCarImagesJson(AllCarImagesOUT);
          setInnerCarImagesJson(AllCarImagesIN);
          if (AllCarImagesIN) setInnerCarImages(AllCarImagesIN[codeColorIN]);
          else setInnerCarImages([]);
          if (AllCarImagesOUT) setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
          else setOuterCarImages([]);
        } else {
          axios
            .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchCarColorCodeImages`, { Id: model, year: vehicle?.year, ColorID: null, FieldNameList: null })
            .then((response) => {
              setIsLoadingImages(false);
              if (Array.isArray(response.data)) {
                const groupResult = mapValues(groupBy(response.data, "ColorCode"), (fList) => fList.map((items) => omit(items, "ColorCode")));
                var allcolor = [...OUTcolorsCode, ...INcolorsCode];
                allcolor?.map((key) => {
                  var colorCodeItems = groupResult[key];
                  if (colorCodeItems?.length > 0) {
                    if (OUTcolorsCode?.includes(key)) {
                      var cimage = cashCarImages[model + "-part-" + 0] || {};
                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 0] = cimage;
                      if (codeColorOUT == key) {
                        imagesPart = colorCodeItems;
                        setOuterCarImages(colorCodeItems);
                      }
                    } else if (INcolorsCode?.includes(key)) {
                      var cimage = cashCarImages[model + "-part-" + 1] || {};
                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 1] = cimage;
                      if (codeColorIN == key) {
                        imagesPart = colorCodeItems;
                        setInnerCarImages(colorCodeItems);
                      }
                    } else {
                      var cimage = cashCarImages[model + "-part-" + 2] || {};
                      cimage[key] = colorCodeItems;
                      cashCarImages[model + "-part-" + 2] = cimage;
                      if (codeColor == key) {
                        imagesPart = colorCodeItems;
                        setWheels(colorCodeItems);
                      }
                    }
                  }
                });
                const imagesCount = imagesPart?.length;
                setAllImagesCount(imagesCount);
                var AllCarImagesIN = cashCarImages[model + "-part-" + 1];
                var AllCarImagesOUT = cashCarImages[model + "-part-" + 0];
                setOuterCarImagesJson(AllCarImagesOUT);
                setInnerCarImagesJson(AllCarImagesIN);
                if (AllCarImagesIN) setInnerCarImages(AllCarImagesIN[codeColorIN]);
                else setInnerCarImages([]);
                if (AllCarImagesOUT) setOuterCarImages(AllCarImagesOUT[codeColorOUT]);
                else setOuterCarImages([]);
                setIsLoadingImages(false);
              }
            })
            .catch((error) => {
              setIsLoadingImages(false);
              cashCarImages[model + "-part-" + partnum] = {};
            });
        }
      } else {
        setIsLoadingImages(false);
      }
    }
  }, [activePart, activeModel?.sn, isLoadingImages, OUTcolorsCode, INcolorsCode, cashCarImages, vehicle?.year]);

  const [gallery, setGallery] = useState([]);
  const [cachSNImages, setCachSNImages] = useState({});

  const FetchCarSNImages = useCallback(async (SN) => {
    try {
      if (cachSNImages && cachSNImages[SN]) {
        setGallery(cachSNImages[SN]);
      } else {
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/siteFetchCarSNImages`, { SN });
        if (response.status == 200) {
          const filterG = [];
          response.data?.map((item) => {
            item["original"] = config.mainURL + item.Image;
            item["thumbnail"] = config.mainURL + item.Image;
            item["originalHeight"] = "50";
            item["originalWidth"] = "50";
            item["sizes"] = "50";
            item["fullscreen"] = config.mainURL + item.Image;
            filterG.push(item);
          });
          setGallery(filterG);
          var cuCachSNImages = { ...cachSNImages };
          cuCachSNImages[SN] = filterG;
          setCachSNImages(cuCachSNImages);
        } else {
          var cuCachSNImages = { ...cachSNImages };
          cuCachSNImages[SN] = [];
          setCachSNImages(cuCachSNImages);
        }
      }
    } catch (error) {
      console.log(error);
      var cuCachSNImages = { ...cachSNImages };
      cuCachSNImages[SN] = [];
      setCachSNImages(cuCachSNImages);
    }
  }, [cachSNImages]);

  const afterChangeDataType = useCallback(async (firstItem, thisSelectedColorID = selectedColor?.ColorID, partnum = activePart) => {
    setIsLoading(true);
    setActiveOutColor("");
    setActiveINColor("");
    setSelectedColor(null);
    resetColorsValues();
    resetValues();
    const colors = await handleFetchModelAvaliableColors(firstItem?.type ?? firstItem?.Type, firstItem?.ColorID ?? firstItem?.colorID, firstItem?.year, thisSelectedColorID);
    var currentSelectedColor = colors?.filter((item) => item.ColorID == thisSelectedColorID)?.length > 0 ? thisSelectedColorID : firstItem?.colorID;
    try {
      if (currentSelectedColor && currentSelectedColor?.split("/")[0] && currentSelectedColor?.split("/")[1]) {
        setActiveOutColor(currentSelectedColor?.split("/")[0]);
        setActiveINColor(currentSelectedColor?.split("/")[1]);
      }
    } catch (error) { }
    if (firstItem) {
      setCarColors(colors);
      await fetchCarDesign(currentSelectedColor, firstItem?.productID);
    }
    setIsLoading(false);
  }, [selectedColor, activePart, handleFetchModelAvaliableColors, fetchCarDesign]);

  const callback = useCallback(async () => {
    setIsLoading(true);
    var curvehicle;
    const vinData = sn ? await fetchVehicleDetailsByVIN(sn) : null;
    try {
      await axios
        .request({
          baseURL: config.controllURL,
          url: config.controllURL + lang + "/api/VehicleOverview/" + (vinData?.brand ?? null) + "/" + slug + "/carDetails",
          method: "get",
        })
        .then(async function (response) {
          if (response.data.vehicle) {
            curvehicle = response.data.vehicle;
            if (vinData) {
              curvehicle = { ...curvehicle, ...vinData };
            }
            setVehicle(curvehicle);
            FetchVehiclePriceList(null, curvehicle?.carGroupID, curvehicle?.year, null, null);
          }
          setFeatures(response.data.features);
          setIsLoading(false);
        })
        .catch(function (error) {
          setIsLoading(false);
        });
    } catch (error) { }

    try {
      const Body = { GUID: slug };
      await axios
        .request({ url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Fetch_InvProductsEquipments`, data: Body, method: "POST", responseType: "json" })
        .then(function (response) {
          const groupResult = mapValues(groupBy(response.data, "ID"), (fList) => fList.map((items) => omit(items, "ID")));
          var dataFinal = [];
          Object.keys(groupResult)?.map((key) => {
            var data = [];
            var note = "";
            groupResult[key].forEach((a, i) => {
              if (lang == "ar") {
                note = note + a.DescriptionAr + "\n" + a.NoteAr + "\n";
                a.note = note;
              } else {
                note = note + a.DescriptionEn + "\n" + a.NoteEn + "\n";
                a.note = note;
              }
              if (i == groupResult[key].length - 1) data = [...data, a];
            });
            dataFinal = [...dataFinal, ...data];
          });
          setExtraDetails(dataFinal);
        })
        .catch(function (error) { });
    } catch (error) { }

    var curentCars;
    try {
      await axios
        .request({
          baseURL: "/",
          url: config.controllURL + lang + "/api/VehicleOverview/" + slugSplitter(curvehicle?.group) + "/" + curvehicle?.year + "/models",
          method: "get",
        })
        .then(async function (response) {
          curentCars = response.data.models?.filter((item) => item.buyOnline == 1);
          var _default = curvehicle;
          _default = curentCars.find((item) => item.type == (vinData?.type || curvehicle?.type)) ?? curvehicle;
          if (_default) {
            setActiveModel(_default);
            afterChangeDataType(_default, vinData?.colorID || vinData?.ColorID || null);
          }
          setModels(curentCars);
        })
        .catch(function (error) {
          afterChangeDataType(curvehicle, sn ? true : null);
        });
    } catch (error) {
      afterChangeDataType(curvehicle, sn ? true : null);
    }

    try {
      await axios
        .request({
          baseURL: "/",
          url: config.controllURL + lang + "/api/VehicleOffer/" + slug + "/offers",
          method: "get",
        })
        .then(async function (response) {
          if (response.data) setVehicleOffers(response.data);
        })
        .catch(function (error) {
        });
    } catch (error) { }
    setIsLoading(false);
  }, [lang, slug, sn, fetchVehicleDetailsByVIN, afterChangeDataType]);

  const GetSuggestedVehicles = async (brandID, category, carGroupID, slug) => {
    try {
      await axios
        .request({
          baseURL: "/",
          url: config.controllURL + lang + "/api/vehicles/OnlineVehicles",
          method: "get",
        })
        .then(async function (response) {
          try {
            var cc = response?.data?.vehicles?.filter((c) => c.sn != sn && c.carGroupID != carGroupID && c.categor == category);
            setSuggestedVehicles(cc);
          } catch (error) {
          }
        })
        .catch(function (error) {
        });
    } catch (error) {
    }
  };

  async function handelfilterBranches(Citey) {
    setSelectBranch(Citey);
    var bc = Branches.filter((branche) => branche.city === Citey);
    setFilterBranches(bc);
  }

  const [dataShippingInfo, setDataShippingInfo] = useState({ "": [] });

  async function CarShippingInfo(Citey) {
    setSelectcity(Citey);
    if (!dataShippingInfo[Citey]) {
      var currentvalue = { ...Shipping };
      currentvalue.Cost = 0;
      currentvalue.UnitTime = null;
      currentvalue.CountTime = null;
      currentvalue.DateTimeDelevry = "";
      let newData = { ...dataShippingInfo };
      newData[Citey] = currentvalue;
      setDataShippingInfo(newData);
      const Body = { City: `${Citey}`, categore: `${vehicle?.carCategories}` };
      await axios
        .request({ url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_CarShippingInfo`, data: Body, method: "POST", responseType: "json" })
        .then(function (response) {
          var currentvalue = { ...Shipping };
          currentvalue.Cost = response.data[0].CostShipping;
          currentvalue.CostWithTax = response.data[0].CostShippingWithTax;
          currentvalue.UnitTime = response.data[0].Type;
          currentvalue.CountTime = response.data[0].TimeDelivary;
          currentvalue.DateTimeDelevry = "";
          setShipping(currentvalue);
          let newData2 = { ...dataShippingInfo };
          newData2[Citey] = currentvalue;
          setDataShippingInfo(newData2);
        })
        .catch(function (error) {
          setShipping(currentvalue);
        });
    } else {
      setShipping(dataShippingInfo[Citey]);
    }
  }

  const handleOnActive = (menuValue) => {
    setActiveFilterMenu(menuValue);
  };

  const handleFetchCountries = async () => {
    let ShippingCities = [];
    try {
      const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_ShippingCities`, {});
      if (response.status == 200) {
        const desc = lang == "ar" ? "DescriptionAr" : "DescriptionEn";
        ShippingCities = response.data.map((item) => ({ value: item.ID, text: item[desc] }));
      }
    } catch (error) { }
    setCities(ShippingCities);
  };

  const [brancheCities, setBrancheCities] = useState([]);
  const handleFetchBrancheCities = async (Branches) => {
    let Cities = [];
    try {
      let valuesC = [];
      Branches.map((item) => {
        if (!valuesC.includes(item.city)) {
          valuesC = [...valuesC, item.city];
          Cities = [...Cities, { value: item.city, text: item[lang == "ar" ? `CityAr` : `CityEn`] }];
        }
      });
      setBrancheCities(Cities);
      setFilterBranches(Branches);
    } catch (error) { }
  };

  const [Branches, setBranches] = useState([]);
  const [filterBranches, setFilterBranches] = useState([]);

  async function GetBranch() {
    const Body = {};
    await axios
      .request({ url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FetchVehicleBranches`, data: Body, method: "POST", responseType: "json" })
      .then(function (response) {
        const result = response.data;
        setBranches(result);
        handleFetchBrancheCities(result);
      })
      .catch(function (error) { });
  }

  const showPanelInfo = (currentIndexPanel) => {
    if (currentIndexPanel != indexPanel) {
      setIndexPanel(currentIndexPanel);
      setShowPanel(true);
    } else {
      setIndexPanel(currentIndexPanel);
      setShowPanel(!showPanel);
    }
  };

  // Moved state declarations up to line 131 to fix ReferenceError

  useEffect(() => {
    var currentInColor = [];
    var IN_colors = [];
    var currentOutColor = [];
    var Out_colors = [];
    var jsoncolors = {};
    try {
      colors?.forEach((item) => {
        jsoncolors[item.ColorID] = item;
        if (!currentOutColor.includes(item.ColorID?.split("/")[0])) {
          Out_colors = [
            ...Out_colors,
            {
              ColorDescription: (item[lang === "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`] || item.ColorDescription)?.split("/")[0],
              ColorID: item.ColorID?.split("/")[0],
              ColorImage: item?.siteOutColorImage || item?.ColorImage,
              ColorHex: item?.ColorHex || item?.siteOutColorHex
            },
          ];
          currentOutColor = [...currentOutColor, item.ColorID?.split("/")[0]];
        }
        if (!currentInColor.includes(item.ColorID?.split("/")[1])) {
          IN_colors = [
            ...IN_colors,
            {
              ColorDescription: (item[lang === "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`] || item.ColorDescription)?.split("/")[1],
              ColorID: item.ColorID?.split("/")[1],
              ColorImage: item?.siteInColorImage || item?.ColorImage,
              ColorHex: item?.ColorHex || item?.siteInColorHex
            },
          ];
          currentInColor = [...currentInColor, item.ColorID?.split("/")[1]];
        }
      });
      setOUTCarColorsCode(currentOutColor);
      setINCarColorsCode(currentInColor);
      setJsonColors(jsoncolors);
      setINCarColors(IN_colors);
      setOUTCarColors(Out_colors);
    } catch (error) { }
  }, [colors]);

  useEffect(() => {
    if (activeOutColor && activeINColor) setSelectedColor(colors.filter((a) => a.ColorID == activeOutColor + "/" + activeINColor)[0]);
    if (activeOutColor && activeINColor && activeModel?.productID) {
      fetchCarDesign(activeOutColor + "/" + activeINColor, activeModel?.productID);
    }
  }, [activeINColor, activeOutColor, OUTcolorsCode]);

  useEffect(() => {
    getActivePartSection(activePart);
  }, [outerCarImages, innerCarImages, wheels, activePart]);

  useEffect(() => {
    if (isLoadingImages == false) getActivePartSection(activePart);
  }, [isLoadingImages]);

  const [filterCarImages, setFilterCarImages] = useState([]);
  const getActivePartSection = async (activePart, thisSelectedColorID = selectedColor?.ColorID, Model = activeModel) => {
    setFilterCarImages([]);
    setActivePart(activePart);
    let result = [];
    if (activePart === 0) {
      if (outerCarImages?.length > 0) result = outerCarImages;
    } else if (activePart === 1) {
      if (innerCarImages?.length > 0) result = innerCarImages;
    } else if (activePart === 2) {
      if (wheels?.length > 0) result = wheels;
    }
    var allImages = [];
    try {
      allImages = outerCarImages.concat(innerCarImages ?? [], wheels ?? []);
    } catch (error) {
      allImages = outerCarImages;
    }
    setFilterCarImages(allImages);
    return result;
  };

  const resetValues = () => {
    setOuterCarImagesJson(null);
    setInnerCarImagesJson(null);
    setAllImagesCount(0);
    setInnerCarImages([]);
    setOuterCarImages([]);
    setWheels([]);
  };

  const resetColorsValues = () => {
    setOUTCarColors([]);
    setINCarColors([]);
  };

  const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);

  const [ServiceID, setServiceID] = useState(null);
  const [allServiceID, setAllServiceID] = useState([]);
  const [Service, setService] = useState(null);
  const [serviceImportantAdditions, setServiceImportantAdditions] = useState(null);
  const [lodingService, setLodingService] = useState(false);

  async function fetchService(option) {
    setService([]);
    setinfoPrice([{ Price: 0 }]);
    setLodingService(true);
    const Body = { VehicleType: vehicle ? vehicle.vehicleType : "" };
    axios
      .request({ url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_FetchProtectionServiceByVehicleType_forNewCar`, data: Body, method: "POST", responseType: "json" })
      .then(function (response) {
        var filterservice = response?.data;
        setTimeout(() => setService(filterservice), 1000);
        var newServiceImportantAdditions = filterservice.find(
          (s) => s["ServiceDetailsEn"].includes("rust") || s["ServiceDetailsEn"]?.includes("Undercoating") || s["ServiceDetails"]?.includes("عازل صد")
        );
        setServiceImportantAdditions(newServiceImportantAdditions);
        setLodingService(false);
      })
      .catch(function (error) {
        setLodingService(false);
      });
  }

  const propsDataPass = {
    vehicle,
    isToyota,
    isLexus,
    selectedColor,
    finance,
    minFinance,
    financeSettings,
    filterCarImages,
    isLoading,
    models,
    banks,
    vehiclePriceList,
    Service,
    ServiceParm: Service,
  };

  return (
    <>
      {page?.toLowerCase() === "overview" && (
        <div className={`car-overview-v2-perfect ${lang === 'ar' ? 'language-ar' : 'language-en'}`} style={{ minHeight: '100%' }}>
          {/* Breadcrumb section like other site pages */}
          <div className="bc"><div className="ctn">
            <Breadcrumb links={[
              { name: trans("info:Online_Cars_Store"), link: `/${lang}/VehicleOnline` },
              { name: vehicle?.name || '' }
            ]} />
          </div></div>

          {/* VEHICLE HERO */}
          <section className="vh"><div className="ctn">
            <div className="vh-row">
              <OverviewHeader
                isLoadingImages={isLoadingImages}
                filterCarImages={filterCarImages}
                history={history}
                trans={trans}
                lang={lang}
                vehicle={vehicle}
                activeModel={activeModel}
                selectedColor={selectedColor}
                cachSNImages={cachSNImages}
                gallery={gallery}
                popGalleryRef={popGalleryRef}
                FetchCarSNImages={FetchCarSNImages}
              />

              <div className="vh-info-inner">
                {!isLoading && selectedColor?.showPric && selectedColor?.buyOnline && (
                  <FinanceCalculator
                    trans={trans}
                    activeFilterMenu={activeFilterMenu}
                    handleOnActive={handleOnActive}
                    vehicle={vehicle}
                    finance={finance}
                    selectedFinancePeriod={selectedFinancePeriod}
                    setSelectedFinancePeriod={setSelectedFinancePeriod}
                  />
                )}
                <DesktopSidebar
                  isLoading={isLoading}
                  selectedColor={selectedColor}
                  trans={trans}
                  finance={finance}
                  minFinance={minFinance}
                  financeSettings={financeSettings}
                  vehicle={vehicle}
                  history={history}
                  lang={lang}
                  Cart={Cart}
                  setCartData={setCartData}
                  isFavoriteItem={isFavoriteItem}
                  changeFavoriteItemState={changeFavoriteItemState}
                  setShareOpened={setShareOpened}
                  setShowFinalPopupMessage={setShowFinalPopupMessage}
                  banks={banks}
                  setFinanceSettings={setFinanceSettings}
                  setSelectedFinancePeriod={setSelectedFinancePeriod}
                  reCountFinanceSettings={reCountFinanceSettings}
                  config={config}
                  OUTcolors={OUTcolors}
                  INcolors={INcolors}
                  activeOutColor={activeOutColor}
                  setActiveOutColor={setActiveOutColor}
                  activeINColor={activeINColor}
                  setActiveINColor={setActiveINColor}
                  setSelectedColor={setSelectedColor}
                />
              </div>
            </div>
          </div></section>

          {/* <Specifications
            vehicle={vehicle}
            vehicleFeatures={vehicleFeatures}
            trans={trans}
          /> */}

          <ProtectionShadingTabs
            vehicle={vehicle}
            lang={lang}
            trans={trans}
            models={models}
            OUTcolors={OUTcolors}
            INcolors={INcolors}
            activeModel={activeModel}
            setActiveModel={setActiveModel}
            selectedColor={selectedColor}
            setSelectedColor={setSelectedColor}
            afterChangeDataType={afterChangeDataType}
            activeOutColor={activeOutColor}
            setActiveOutColor={setActiveOutColor}
            activeINColor={activeINColor}
            setActiveINColor={setActiveINColor}
            fetchCarDesign={fetchCarDesign}
            resetColorsValues={resetColorsValues}
            config={config}
            isLoading={isLoading}
          />

          {extraDetails?.length > 0 && (
            <ExtraDetailsPanel
              extraDetails={extraDetails}
              lang={lang}
              trimEnd={trimEnd}
            />
          )}



          <div className="ctn pb-10">
            <DeliveryInfo
              cities={cities}
              brancheCities={brancheCities}
              filterBranches={filterBranches}
              selectcity={selectcity}
              selectBranch={selectBranch}
              CarShippingInfo={CarShippingInfo}
              handelfilterBranches={handelfilterBranches}
              deliveryTimeAccounting={deliveryTimeAccounting}
              trans={trans}
            />
          </div>

          {/* Suggested Section */}
          {!isLoading && suggestedVehicles?.length > 0 && (
            <SuggestedVehicles
              suggestedVehicles={suggestedVehicles}
              trans={trans}
            />
          )}

          {/* Mobile Footer */}
          <MobileStickyFooter
            isLoading={isLoading}
            selectedColor={selectedColor}
            trans={trans}
            finance={finance}
            financeSettings={financeSettings}
            lang={lang}
            vehicle={vehicle}
            history={history}
            scrollSnackUp={scrollSnackUp}
            setScrollSnackUp={setScrollSnackUp}
            setShowFinalPopupMessage={setShowFinalPopupMessage}
          />

          {/* Popups */}
          {shareOpened && (
            <SharePopup
              shareOpened={shareOpened}
              setShareOpened={setShareOpened}
              title={shareData.title}
              url={shareData.url}
              hashTag={shareData.hashTag}
              lang={lang}
              trans={trans}
            />
          )}

          {showFinalPopupMessage && (
            <FinancingDetailsPopup
              show={showFinalPopupMessage}
              setShow={setShowFinalPopupMessage}
              finance={finance}
              financeSettings={financeSettings}
              lang={lang}
              trans={trans}
            />
          )}

          <div style={{ opacity: isFullScreen ? 1 : 0, transition: 'all .3s', position: isFullScreen ? "relative" : "fixed", zIndex: isFullScreen ? 999999 : -1 }}>
            <ImageGallery ref={popGalleryRef} items={gallery} onScreenChange={(e) => setIsFullScreen(e)} />
          </div>
        </div>
      )}

      {/* Checkout Pages */}
      {
        page?.toLowerCase() === "checkout" && (
          <CarCheckoutPage
            {...propsDataPass}
            parmActiveModel={activeModel}
            vehicle={vehicle}
            isToyota={isToyota}
            isLexus={isLexus}
            selectedColor={selectedColor}
            finance={finance}
            minFinance={minFinance}
            financeSettings={financeSettings}
            filterCarImages={filterCarImages}
            isLoading={isLoading}
            models={models}
          />
        )
      }
      {
        page?.toLowerCase() === "reservation" && (
          <CarCheckoutReservationPage
            {...propsDataPass}
            parmActiveModel={activeModel}
            vehicle={vehicle}
            isToyota={isToyota}
            isLexus={isLexus}
            selectedColor={selectedColor}
            finance={finance}
            minFinance={minFinance}
            financeSettings={financeSettings}
            filterCarImages={filterCarImages}
            isLoading={isLoading}
            models={models}
            ServiceParm={Service}
          />
        )
      }
      {
        page?.toLowerCase() === "accessories" && (
          <CarCashAccessoriesPage
            {...propsDataPass}
            parmActiveModel={activeModel}
            vehicle={vehicle}
            isToyota={isToyota}
            isLexus={isLexus}
            selectedColor={selectedColor}
            finance={finance}
            minFinance={minFinance}
            financeSettings={financeSettings}
            filterCarImages={filterCarImages}
            isLoading={isLoading}
            models={models}
            ServiceParm={Service}
          />
        )
      }
      {
        page?.toLowerCase() === "checkoutcash" && (
          <CarCheckoutCashPage
            {...propsDataPass}
            parmActiveModel={activeModel}
            vehicle={vehicle}
            isToyota={isToyota}
            isLexus={isLexus}
            selectedColor={selectedColor}
            finance={finance}
            minFinance={minFinance}
            financeSettings={financeSettings}
            filterCarImages={filterCarImages}
            isLoading={isLoading}
            models={models}
            ServiceParm={Service}
          />
        )
      }
      {
        page?.toLowerCase() === "checkoutfinance" && (
          <CarCheckoutFinancePage
            {...propsDataPass}
            parmActiveModel={activeModel}
            vehicle={vehicle}
            isToyota={isToyota}
            isLexus={isLexus}
            selectedColor={selectedColor}
            Pfinance={finance}
            minFinance={minFinance}
            PfinanceSettings={financeSettings}
            PvehiclePriceList={vehiclePriceList}
            filterCarImages={filterCarImages}
            isLoading={isLoading}
            models={models}
            banks={banks}
          />
        )
      }
    </>
  );
}
